import styled from 'styled-components';

export const PageHeading = styled.h1`
  font-weight: 500;
  text-align: center;
  margin: 10px 0px 10px;
  color: var(--accent-color);
`;
